import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Link } from '@bingads-webui-campaign-react/router';
import { GlobalErrorView } from '@bingads-webui-react/app-global-error-view';

export function ErrorView(props) {
  const i18n = useContext(I18nContext);
  const { taskState } = props;

  const errorDescriptionMap = {
    fail: i18n.getString(_TL_("We've encountered an error. Please try again or contact support.")),
    invalidId: i18n.getString(_TL_('The report does not exist or does not belong to current user, manager account or account.')),
    deprecate: i18n.getString(_TL_('This report type has been deprecated and is no longer available.')),
  };

  return (
    <GlobalErrorView
      title=""
      description={
        [
          errorDescriptionMap[taskState] || '',
          () => <Link to={{ pathname: '/campaign/vnext/reports-v4/my-reports', search: window.location.search }}>{i18n.getString(_TL_('Back to custom reports'))}</Link>,
        ]
      }
    />
  );
}

ErrorView.propTypes = {
  taskState: PropTypes.string.isRequired,
};
